// Subtasks: tasks whose parent_id names another task (backend utils/subtasks.py).
// One rule for every list: a subtask shows under its parent when the parent is in the
// same list, and as a row of its own otherwise - never not at all. So no page filters
// subtasks out of the tasks it shows; the list nests them.

/**
 * The rows of a list in display order: each task once, its subtasks right after it
 * (depth + 1), all in the order the list gives them. A task whose parent is not in the
 * list is a top-level row. Subtasks of a task in `collapsed` are left out.
 * Each row: { task, depth, childCount } (childCount = its subtasks in this list).
 */
export function nestTasks(tasks = [], collapsed = null) {
  const ids = new Set(tasks.map((t) => t.id));
  const children = new Map();
  const roots = [];
  tasks.forEach((task) => {
    if (task.parent_id && task.parent_id !== task.id && ids.has(task.parent_id)) {
      if (!children.has(task.parent_id)) children.set(task.parent_id, []);
      children.get(task.parent_id).push(task);
    } else {
      roots.push(task);
    }
  });

  const rows = [];
  const placed = new Set();
  const place = (task, depth, hidden) => {
    if (placed.has(task.id)) return;
    placed.add(task.id);
    const kids = children.get(task.id) || [];
    if (!hidden) rows.push({ task, depth, childCount: kids.length });
    const hideKids = hidden || !!collapsed?.has(task.id);
    kids.forEach((kid) => place(kid, depth + 1, hideKids));
  };
  roots.forEach((task) => place(task, 0, false));
  // Parents in a loop (A under B under A) have no top: they start at the top level.
  tasks.forEach((task) => place(task, 0, false));
  return rows;
}

/** Done / all subtasks of a task, from the counts the server adds to every listed task. */
export function subtaskProgress(task) {
  const total = task?.subtask_count || 0;
  return total > 0 ? { done: task.completed_subtask_count || 0, total } : null;
}
